import { gql } from '@/__generated__';

export const upsertCustomerDocument = gql(/* GraphQL */ `
  mutation UpsertCustomer(
    $where: CustomerWhereUniqueInput!
    $create: CustomerCreateInput!
    $update: CustomerUpdateInput!
  ) {
    upsertCustomer(where: $where, create: $create, update: $update) {
      id
      pageId
      name
      email
      avatar
      createdAt
      updatedAt
    }
  }
`);
